export const environment = {
  production: true,
  version: '1.0.0',
  COMPANY_ID: "UNITYCRM0021",

  CAS_BASE_RUL:'https://identity-stg.aqsatel.com/',
  BASE_API: "https://api-manage.aqsatel.com/",
  AQSATEL_API: "https://api-manage.aqsatel.com/",
  Prepaid_Mingle_API: "https://plum-mig.aqsatel.com/",


  // Authorize.Net Accept.js Configuration (Production)
  AUTHORIZE_NET: {
    API_LOGIN_ID: 'YOUR_PRODUCTION_API_LOGIN_ID', // Replace with actual production API Login ID
    PUBLIC_CLIENT_KEY: 'YOUR_PRODUCTION_PUBLIC_CLIENT_KEY', // Replace with actual production Public Client Key
    SCRIPT_URL: 'https://js.authorize.net/v1/Accept.js',
    API_ENDPOINT: 'https://api2.authorize.net/xml/v1/request.api'
  },

  UNITY_BUYFLOW: "https://prepaid.aqsatel.com",
  MINGLE_BUYFLOW: "https://prepaid.aqsatel.com",

  USER_ID: "1",
  FETCH_DATA_REPORT_TABLE_INTERVAL: 3,
  PREPAID_UNITYWIRELESS: "https://prepaid.aqsatel.com/",

  MINGLE_MOBILE: "https://minglemobile.com",
  // session timeout or user inactivity constants
  INACTIVITY_SCREEN_TIME_IN_MINIUTES: 60,
  JWT_EXPIRATION_TIME_IN_MINUTES: 60,
  JWT_EXPIRATION_WARNING_TIME_IN_MINUTES: 5,
  INACTIVITY_SCREEN_TIMEOUT_TIME_IN_Millisconds: 60000,
  
  // notification keys
  CLOSE_ALL_POPUP_ON_MAIN_APP_CLICK: 'closeAllPopupsOnMainAppClick',
  TOGGLE_SEARCH_SUGGESTIONS: 'toggleSearchSuggestions',
  CLEAR_SEARCH_HISTORY: 'clearSearchHistory',
  
  enableConsoleLogs: false,

  // Data unit conversion factor: 1000 = decimal (GB/MB), 1024 = binary (GiB/MiB)
  DATA_UNIT_CONVERSION: 1000,
  // Conversion factor used on /customers/dashboard (binary: 1024)
  DATA_UNIT_CONVERSION_DASHBOARD: 1024,

  // Company information (matching dev environment)
  COMPANY_INFO: {
    unityWireless: {
      phoneNo: '(954) 613 6051',
      officialName: 'Unity Wireless',
      supportEmail: 'support@gounitywireless.com',
      companyAddress: '21113 Johnson St. Ste 101 Pembroke Pines FL 33029',
      copyrightDescription: '© 2024 Unity Wireless All Rights Reserved.'
    },
    mingleMobile: {
      phoneNo: '(800) 974 6122',
      officialName: 'Mingle Mobile',
      supportEmail: 'support@minglemobile.com',
      companyAddress: '21113 Johnson St. Ste 101 Pembroke Pines FL 33029',
      copyrightDescription: '© 2024 Mingle Mobile All Rights Reserved.'
    }
  },

  // Additional environment constants
  REVERB_HOST: 'prepaid-api.aqsatel.com',
  REVERB_PORT: 8081,
  REVERB_SCHEME: 'http',
  searchHistoryStorageBasis: "days",
  searchHistoryDaysToKeep: 2,
  CUSTOMER_DASHBOARD_ACTIVITY_NOTES_GROUPING: {
    timeWindowMinutes: 5,
    keywords: {
      subscription: ['subscription created', 'subscription updated', 'subscription info'],
      planChange: ['plan change', 'planchange', 'change plan'],
      payment: ['payment', 'charged', 'captured'],
      paymentAll: ['failed', 'card'],
      equipment: ['equipment', 'equipmentpurchase'],
      topup: ['topup', 'top up'],
      ticket: ['ticket#'],
      simChange: ['sim changed', 'sim change'],
      statusChangeAll: ['status', 'changed'],
      note: ['note']
    }
  },
  TE_AGENT_BASE_URL: 'https://assistance.telcoedge.com',

  // Stripe Configuration (Production)
  // STRIPE_PUBLISHABLE_KEY: 'pk_test_f4XYknGSOAkXbyu3eYou13Tz00Q9GG6ILN', // Replace with actual Stripe live publishable key

  // Braintree Configuration (Production)
  BRAINTREE: {
    ENVIRONMENT: 'production',
    TOKENIZATION_KEY: 'YOUR_PROD_BRAINTREE_TOKENIZATION_KEY' // Replace with actual Braintree production tokenization key
  },

  // Sentry Monitoring — set sentryDsn to your project's DSN to enable error tracking
  sentryDsn: 'https://df16f9170592504c05c0165ab2fdc3c2@o4508377603506176.ingest.us.sentry.io/4511372076253184', // e.g. https://xxxxxx@oxxxx.ingest.sentry.io/xxxxxxx
  sentryEnvironment: 'production',

  // Maintenance Mode — per-module control
  maintenance: {
    global: false,
    message: 'We are under maintenance',
    subtitle: 'Have a tea break! We will notify you when the system is up.',
    modules: {
      dashboard: false,
      customers: false,
      orders: false,
      fullfillment: false,
      awaitingShipment: false,
      tickets: false,
      reports: false,
      renewalReports: false,
      bulkProcess: false,
      payments: false,
      settings: false,
      adhocInvoice: false,
      porting: false,
      subscriptions: false,
      customerEmail: false,
      executiveDashboard: false,
      inventory: false,
    }
  },
};
